import React, { useState, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from 'moment';
import redirectURL from "../redirectURL";

const BulkUploadModal = ({ show, onClose, columnDefs, rowData,templateUrl, screen }) => {
    const [file, setFile] = useState(null);
    const [loader, setLoader] = useState(false);
    const [modalloadData, setModalLoadData] = useState(rowData || []);  
    const [columnDef] = useState([/* Define your column defs here */]);
    const [defaultColDef] = useState({ /* Your default column defs */ });
    const gridApi = useRef(null);
    const fileInputRef = useRef(null);

    const [show1, setShow1] = useState(false)
    const [type, setType] = useState('default')

    const [title, setTitle] = useState('')
    const changeFileHandler = (e) => {
        setFile(e.target.files[0]);
        setLoader(true);
        const formData = new FormData();
        formData.append("fileUpload", e.target.files[0]);
        formData.append("screen", screen);

        redirectURL.post("/readExcelMasters", formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then(response => {
                if (response.data.status === "success") {

                    if (response.data.data.length > 0) {
                        setModalLoadData(response.data.data);
                    } else {
                        setModalLoadData([]);
                    }
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => setLoader(false));
    };

    const saveConsignments = async (e) => {
        e.preventDefault();
        setLoader(true);
        if (gridApi.current) {
            gridApi.current.stopEditing();
            const gridRowData = [];
            gridApi.current.forEachNode((node) => {
                gridRowData.push(node.data);
            });
            
            if (gridRowData.length > 0) {
                await redirectURL.post("/bulkUploadMasters", { master_data: gridRowData, master_type: screen })
                    .then(response => {
                        if (response.data.status === "success") {
                            setShow1(true)
                            setTitle(response.data.message)
                            setType("success")
                            setLoader(false)
                            // setBulkUploadModal(false)
                            setModalLoadData([])
                            // setOverlay("show-n")
                            setFile(null); 
                            onClose()
                            // window.location.reload()
                        } else {
                            setShow1(true)
                            setTitle(response.data.message)
                            setType("danger")
                            setLoader(false)                        }
                    })
                    .catch(err => console.log(err))
                    .finally(() => setLoader(false));
            }
        }
    };
    const handleClose = () => {
        setFile(null); // Reset the file state
        setModalLoadData([])

        if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Reset the file input element
        }
        onClose(); // Call the parent onClose
    };
    const onConfirm = () => {
        setShow1(false);
        setLoader(false)
        window.location.reload()
    };

    return (
        <>
        <SweetAlert
        show={show1}
        title={<span style={{ fontSize: "1rem" }}>{title}</span>}
        onConfirm={onConfirm}
        confirmBtnBsStyle={type}
        confirmBtnCssClass="sweetButton"
        customClass='sweetWidth'
        type={type}>
    </SweetAlert>
        {show && (
            <div className={"slide-r " + (show ? "slider-translate-84p" : "")} style={{ overflow: "auto" }}>
                <h3 className="subH">Bulk Upload Consignments
                    <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={handleClose}>X</span>
                </h3>

                <div className="slide-r-body" style={{ position: "relative" }}>
    <div className="container-fluid">
    <div className="col-xl-12 col-lg-12" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginLeft:"-30px" }}>

    <form method="POST" id="upform" className="theme-form" style={{marginBottom:"20px"}}>
        <div className='d-flex'>
    <div className="col-xl-3 col-lg-3 form-group mt-30p">
                <a className="btn btn-primary" href={templateUrl} target="_blank"><i class="icofont icofont-download mr-10p"></i>
                    Sample Template
                </a>
            </div>
    <div className="col-xl-9 col-lg-9 form-group">
                <label>Upload File</label>
                <input
                    type="file"
                    name="uploadFile"
                    id="bulkUploadCritical"
                    style={{width:"500px"} }
                    onChange={changeFileHandler}
                    className="form-control"
                    required
                    ref={fileInputRef}
                    value={file ? undefined : ""}
                />
            </div>
            </div>
            
        </form>
        {window.location.pathname.includes("locationmaster") && (
        <div className="form-group1">
            <span style={{ color: "red" }}>Note:</span>
            <div className="d-flex flex-col" style={{ color: "#808080" }}>
                Mobile Number must be 10 digits<br />
                Email, Latitude and Longitude should be valid 
            </div>
        {/* <div className="form-group" style={{ marginRight: "8px" }}>
            <div>
                <i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value
            </div>
        </div> */}
    </div>
)}
</div>
        <div className='col-xl-12 col-lg-12' style={{ display: "flex", alignItems: "center", justifyContent: "end", marginTop:"-30px"}}>
                                
                                <div className='form-group' style={{ marginRight: "8px" }}>
                                    <div className='bulk-invalid-text'><i className="fa fa-circle" style={{ color: "#c85f62" }}></i>&nbsp; Invalid Field Value</div>
                                    {/* <div><i className="fa fa-circle" style={{ color: "#ffcc00" }}></i>&nbsp; Order Number and FO Number combination already exists</div>  */}
                                 </div>
                            </div> 
       


        <div className="ag-theme-balham mt-2" style={{ height: "58vh", width: "100%" }}>
            <AgGridReact
                columnDefs={columnDefs}
                rowData={modalloadData}
                defaultColDef={defaultColDef}
                onGridReady={(params) => (gridApi.current = params.api)}
                pagination={true}
                paginationPageSize={50}
            />
        </div>
        <br />
        <div className="form-group">
            <button type="submit" className="btn btn-success border-radius1 mr-20p" onClick={saveConsignments}>
                Submit
            </button>
            &nbsp;
            <button type="button" onClick={handleClose} className="btn btn-default border-radius1" style={{fontWeight:600}}>
                Cancel
            </button>
        </div>
        <br />
    </div>
</div>

            </div>
        )}
        </>

    );
};

export default BulkUploadModal;
